// extracted by mini-css-extract-plugin
export default {"wrapper":"App_wrapper__Mru9Z","main":"App_main__nhgh3"};